import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendGetRequest, sendPatchRequest } from '../../../api/requestUtil';

export const toggleUpvoteBlogDiscussion = createAsyncThunk(
  'discussionUpvote/toggle',
  async (
    // 💡 UPDATE: Use contentId and include contentType
    {
      contentId,
      discussionId,
      contentType,
    }: {
      contentId: number;
      discussionId: number;
      contentType: 'blog' | 'article' | 'clearing';
    },
    { getState }
  ) => {
    const {
      user: { authToken },
    } = getState() as AppState;

    try {
      // 💡 DYNAMICALLY CONSTRUCT THE PATH
      const basePath = contentType === 'article' ? 'articles' : contentType === 'clearing' ? 'clearings' : 'blogs';

      const response = await sendPatchRequest(
        // Use basePath and contentId
        `/api/${basePath}/${contentId}/discussions/${discussionId}/upvote-discussion/`,
        {},
        authToken
      );

      return response;
    } catch (error) {
      throw new Error('Failed to toggle upvote');
    }
  }
);
export const fetchDiscussionUpvoteStatus = createAsyncThunk(
  'discussionUpvote/fetchStatus',
  async (
    {
      contentId,
      discussionId,
      contentType,
    }: {
      contentId: number;
      discussionId: number;
      contentType: 'blog' | 'article' | 'clearing';
    },
    { getState }
  ) => {
    const {
      user: { authToken },
    } = getState() as AppState;

    if (!contentId || !discussionId || !contentType) {
      throw new Error('Missing parameters for upvote status fetch');
    }

    const basePath = contentType === 'article' ? 'articles' : contentType === 'clearing' ? 'clearings' : 'blogs';
    const response = await sendGetRequest(
      `/api/${basePath}/${contentId}/discussions/${discussionId}/upvote-status-discussion/`,
      authToken
    );

    return {
      discussionId,
      data: {
        contentId: contentId,
        total_upvotes: response.total_upvotes,
        user_has_upvoted: response.user_has_upvoted,
        loading: false,
        error: null,
      },
    };
  }
);
